const prospectiveOptions = [
  { value: 'Founding community member', label: 'Founding community member' },
  { value: 'Investor', label: 'Investor' },
  { value: 'Strategic partner', label: 'Strategic partner' },
  { value: 'Other', label: 'Other' }
]

export { prospectiveOptions };